export default "__VITE_ASSET__Cjtay5NA__"